import { useEffect, useState } from "react";
import { ApplicationState, applicationState, initialState } from "shared/store/applicationState";

export default function useSelector<T>(selector:(state: ApplicationState) => T ): T {
    const [val, setVal] = useState(initialState);

    useEffect(() => {
        var sub = applicationState.subscribe(setVal); 
        return () => sub.unsubscribe();
    }, []);

    return selector(val);
}
